
import React from "react";
import { Navigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import { JwtPayload } from "jwt-decode";

const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    if (decoded.exp) {
      return decoded.exp * 1000 < Date.now();
    }
    return true;
  } catch (error) {
    // console.error("Error decoding token:", error);
    return true;
  }
};

interface PrivateRouteProps {
  children: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token || isTokenExpired(token)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default PrivateRoute;
